import React from 'react';
import { Link } from 'react-router-dom';

const Card = ({ product }) => {
  if (!product) return null;

  return (
    <div className="ith-prod-card">
      {/* Brand Header: Logo & Name */}
      <div className="ith-prod-header">
        <div className="ith-brand-logo-box">
          <img src={product.thumbnail} alt={product.title} />
        </div>
        <div className="ith-brand-info">
          <h4 className="ith-brand-title">{product.title}</h4>
          <p className="ith-brand-desc">{product.shortDescription}</p>
        </div>
      </div>

      {/* Product Image Grid (4 Images) */}

      {/* View More Button */}
      <div className="ith-card-footer text-center">
        <Link to={`/shop/${product.slug || product._id}`} className="ith-explore-more-btn text-center" >
          Explore All  <i className="fas fa-arrow-right ms-2"></i>
        </Link>
      </div>
    </div>
  );
};

export default Card;